import { errorStatusMessage } from './errorStatusMessage';
import { promotions } from './promotions';
import { dashboardLocale } from './dashboard';

export const locale = {
  ...errorStatusMessage,
  ...promotions,
  dashboardLocale,
  changeLang: 'Changer langue',
  changePas: 'Changer pasword',
  logout: 'Deconnecter',
  other: 'Other',

  newPlayer: 'Nouveau client',
  userName: 'Nom de utilisateur',
  username: 'Nom de utilisateur',
  password: 'Mot de passe',
  createAccount: 'Creer un compte',
  '/user-create': 'Cash register - New player',
  '/total': 'Cash register - comptabilitee',
  '/': 'Menu',
  '/locale': 'Languagies',
  '/change-pas': 'Changer pasword',
  '/user-edit': 'Cash register - User edit',

  '/users-list': 'Cash register - balance des clients',
  userCardBalances: 'Balances des clients',
  userCard: 'Clients',
  accountBalance: 'Balance de compte',
  nickname: 'Nom de utilisateur',
  id: 'Identifiant',
  balance: 'Balance',
  ban: 'Bloquer',
  banSuccess: 'Bloquer success',
  unbanSuccess: 'Debloquer success',
  unban: 'Debloquer',
  resetPassword: 'Réinitialiser',
  resetSuccess: 'Mot de passe réinitialisee',
  networkError: 'Erreur de reseau',
  createSuccess: 'Succès de creation',
  topUp: 'Depot',
  withdrawal: 'Retrait',
  topUpSuccess: 'Succès  de depot',
  withdrawalSuccess: 'Succès  de retrait',
  topUpWithdrawal: 'Depot/Retrait',
  ok: 'Ok',
  theNewPassword: 'Nouveau mot de passe',
  for: 'pour',

  '/transaction-history': 'clients - Historique de transactions',
  '/withdrawal-history': 'Historique des retraits',
  startDate: 'Date de debut',
  endingDate: 'fin',
  display: 'Representer',
  email: 'Nom de utilisateur',
  date: 'Date',
  amount: 'Montant',

  languageSelection: 'selectionner langues',
  login: 'Me Connecter',

  cashRegister: 'Cash register',
  partners: 'clients',
  createUser: {
    1: 'Nouvel joueur',
    2: 'Nouvelle caissière',
    3: 'Nouvel admin',
    7: 'Nouvel superadmin',
  },
  balances: {
    1: 'User cards balances',
    2: 'Shop cards balances',
    3: 'Admins cards balances',
    7: 'Superadmins cards balances',
  },
  cashiersTransactions: {
    1: 'Cashier transactions',
    2: 'Shop transactions',
    3: 'Admins transactions',
    7: 'Superadmins transactions',
  },
  transactionHistory: 'Historique des transactions',
  revenuBalances: 'Revenu balances',

  total: 'Totale',
  term: 'Terme',
  cashPayment: 'Payement en espece',
  cashPayout: 'Deboursement en espece',
  withdraw: 'Retrait',
  deposit: 'Depot',
  search: 'Search',
  errorPassword:
    'Le mot de passe doit comprendre: au moins 8 caractères, au moins un chiffre, une majuscule et une minuscule!',
  noPass: 'Le mot de passe ne doit pas être vide!',

  passwordNotHasSY: 'Le mot de passe doit contenir un caractère spécial',
  passwordNotHasCL: 'Le mot de passe doit contenir une lettre majuscule',
  passwordNotHasNumber: 'Le mot de passe doit contenir un nombre',
  passwordTooShort: 'Le mot de passe doit contenir plus de 8 caractères',
  passwordNotHasLetter: 'Le mot de passe doit contenir une lettre',

  social: 'Official X10tn contacts:',
  alert:
    'TOUS LES AUTRES CONTACTS SONT DES ARNAQUES. SEUL NOTRE CONTACT PEUT VENDRE LE SOLDE! NE CRAQUEZ PAS POUR LES RÉDUCTIONS!',

  players: 'Joueurs',
  subusers: 'Sous-utilisateurs',
  tree: 'Tree',
  mysteryBalance: `Mystère
équilibre`,
  mysteryBalanceInfo:
    'Il s\'agit d\'un solde mystique qui sera distribué tous les <span style="color: #FFB401;">3 jours</span> ! Enregistrez plus de joueurs et obtenez plus d\'équilibre mystique avec lequel vous pouvez recharger les soldes des joueurs. Après le dépôt, les joueurs devront miser le montant du solde mystère, 1 pour 1 dans les sports et 1 pour 2 dans les jeux, c\'est-à-dire si vous déposez <span style="color: #FFB401;">100 TND</span> de solde mystère, alors pour retirer de l\'argent le joueur devra parier <span style="color: #FFB401;">100 TND</span> dans le sport ou <span style="color: #FFB401;">200 TND</span> dans les jeux.',
  roles: {
    0: 'Joueur',
    1: 'Caissier',
    2: 'Admin',
    3: 'Superadmin',
  },
  myBalance: 'Mon solde',
  areUSure: 'Êtes-vous sûr de vouloir sortir ?',
  comeBack: 'Non, reviens',
  cancel: 'Annuler',
  yes: 'Oui',
  newPassword: 'Nouveau mot de passe',
  confirmNewPassword: 'Confirmer le nouveau mot de passe',
  applyChanges: 'Appliquer les modifications',
  cashiers: 'Caissiers',
  admins: 'Administrateurs',
  users: 'Utilisateurs',
  totalUsers: "Nombre total d'utilisateurs",
  userId: 'User ID',
  role: 'Rôle',
  results: 'Résultats',
  about: 'À propos',
  userDate: 'Données utilisateur',
  copiedSuccessfully: 'Copié avec succès',
  myTransfers: 'Mes transferts',
  transactionsHistory: 'Historique des transactions',
  create: 'Créer',
  repeatPassword: 'Répéter le mot de passe',
  from: 'Depuis',
  to: 'À',
  show: 'Montrer',
  totalDeposits: 'Dépôts totaux',
  totalWithdrawals: 'Retraits totaux',
  deposits: 'Dépôts',
  withdrawals: 'Retraits',
  operationType: "Type d'opération",
  operationTypes: {
    0: 'Retraits',
    1: 'Dépôts',
  },
  operation: 'Opération',

  withdrawalAmount: 'Montant du retrait',
  status: 'Statut',
  newRequest: 'Nouvelle demande',
  filters: 'Filtres',
  requests: 'Demandes',
  approve: 'Approuver',
  reject: 'Rejeter',
  note: 'Note',

  userLogin: 'User login',
  created: 'Created',
  completed: 'Completed',
  rejected: 'Rejected',

  requestRejection: 'Refus de la demande',
  youRejected: "Vous avez refusé une demande d'un montant de",
  comment: 'Commentaire',
  writeExplanation: 'Veuillez indiquer la raison du refus. Votre commentaire sera visible par le joueur.',
  send: 'Envoyer',
  cancel: 'Annuler',
  emptyActiveRequests: 'Aucune demande active',

  activeRequests: 'Demande de retrait active',
  withdrawalHistory: 'Historique des retraits',

  filters: 'Filtres',
  id: 'ID',
  username: 'Nom d’utilisateur',
  from: 'Depuis',
  to: 'À',
  show: 'Afficher',
  toggle: 'Basculer',

  payment: 'Paiement',
  suDeposit: 'Dépôt',
  choosePayment: 'Choisissez le paiement',
  paymentAmount: 'Entrez le montant du paiement',
  youWillGet: 'Vous recevrez sur votre solde :',
  minDeposit: 'Dépôt minimum',
  maxDeposit: 'Dépôt maximum',
  rate: 'Taux',
  onYourBalance: 'sur votre solde',
  enterThePaymentAmount: 'Entrez le montant du paiement',
  balanceAmountForPurchase: 'Montant du solde à acheter',
  rate: 'Taux',
  topUp2: 'Recharger',
  addressForReplenishment: 'Adresse de réapprovisionnement',
  network: 'Réseau',
  enterThePaymentPurchase: "Entrez le paiement d'achat",
  agentNeedsToSendFundsToTheSpecifiedAddress: "L'agent doit envoyer des fonds à l'adresse spécifiée.",
  refillTimer: 'Minuterie de recharge',
  imPaid: "J'ai payé",
  weAreWaitingForThePaymentToArriveDescription:
    "Nous attendons l'arrivée du paiement, une fois les fonds crédités, votre solde sera augmenté",
  weAreWaitingForThePaymentToArrive: 'Nous attendons que le paiement arrive',
  congratulationsTheFundsHaveBeenCredited: 'Félicitations, les fonds ont été crédités, vous pouvez fermer la page',
  timeSpent: 'Temps passé',
  topUpAgain: 'Recharger à nouveau',
  replenishmentFailed: 'Le réapprovisionnement a échoué',

  paymentHistory: 'Historique des paiements',
  success: 'Succès',
  timeIsUp: "Le temps s'est écoulé",
  pending: 'En attente',
  amountPaid: 'Montant payé',
  amountOfPurchasedBalance: 'Montant du solde acheté',
  back: 'Dos',
  failed: 'Échoué',
  withdrawalMoney: "Retrait d'argent",
  readInstructions: 'Lire les instructions',
  instruction: 'instruction',
  instructionText1: `Le site dispose d'un nouveau système de travail avec les joueurs. Désormais, vous ne pouvez plus retirer d'argent du solde des joueurs sans leur demande de retrait. Le joueur peut faire une demande de retrait par lui-même via le site Web. Vous pouvez travailler avec ces demandes de retrait sur cette page.`,
  instructionText2: `À chaque demande, vous disposez des informations nécessaires sur le joueur. Chaque demande a également deux boutons:

<b>1.</b> Approuver - vous utilisez ce bouton pour confirmer la demande de retrait du joueur.
<b>2.</b> Rejeter - vous pouvez utiliser ce bouton pour rejeter une demande de retrait d'un joueur, s'il y a des raisons à cela. Dans les commentaires, vous devez spécifier la raison du rejet de la demande de retrait.

Dans l'onglet" demandes de retrait actives", vous verrez le nombre de demandes actives réelles des joueurs. Vous devez travailler avec eux pour vous assurer de ne pas laisser les demandes des joueurs sans réponse.

Dans l'onglet "Historique des retraits" , vous pouvez consulter l'historique complet de chaque demande de retrait que vous avez effectuée.`,

  statuses: {
    Created:
      'Après transfert de fonds réussi en devise TND, vous devez envoyer un reçu et un identifiant de transaction à votre gestionnaire sur WhatsApp ou Telegram. Il vous créditera votre solde',
    Fail: "Une erreur s'est produite. Si vous avez des questions, veuillez contacter votre gestionnaire.",
    Cancel: 'Le paiement a été annulé. Si vous avez des questions, veuillez contacter votre gestionnaire.',
    null: 'Statut inconnu, veuillez contacter le support technique!',
  },
  dashboard: 'Tableau de bord',

  notification: 'Notification',
  showAll: 'Afficher tout',
  new: 'Nouveau',
  typesOfNotifications: {
    attension: 'Attention',
    personal: 'Personnel',
    deposit: 'Dépôt',
    withdrawal: 'Retrait',
  },
  noNotifications: 'Aucune notification trouvée',

  totalBetAmount: 'Montant total des paris',
  totalWinnings: 'Montant total des gains',
  totalGGR: 'Montant total du GGR',
  betHistory: 'Historique des paris',
  slotsHistory: 'Historique des paris',
  all: 'Tout',
  type: 'Type',
  provider: 'Fournisseur',
  show: 'Afficher',
  win: 'Gagnant',
  lost: 'Perdant',
  bet: 'Parie',
  userIDWarning:
    "L'identifiant de l'utilisateur n'a pas été saisi. Pour afficher l'historique des paris, spécifiez l'identifiant de l'utilisateur",

  myStatistic: 'Mes statistiques',
  compare: 'Comparer',
  playerBalance: 'Équilibre du joueur',
  readMore: 'En savoir plus',
  agentBalance: "Solde de l'agent",
  noResultsFound: 'Aucun résultat trouvé',
  netwin: 'Netwin',
  bets: 'Paris',
  wins: 'Victoires',
  actualBalance: 'Solde réel',
  startBalance: 'Équilibre initial',
  endBalance: 'Équilibre final',
  changeBalance: 'Changer le solde',
  agentsBalance: 'Les agents équilibrent',
  balanceOfPlayers: 'Équilibre des joueurs',
  balanceOf: {
    0: 'Équilibre des joueurs',
    1: 'Solde des caissiers',
    2: 'Solde des administrateurs',
  },
  dateFrom: 'Dater de',
  dateTo: 'Date à',
  acceptFilter: "Filtre d'acceptation",
  totalBets: 'Total des mises',
  totalWin: 'Victoires totales',
  totalNetwin: 'Netwin total',
  margin: 'Marge',
  myAgents: 'Mes agents',
  myPlayers: 'Mes Joueurs',
  activeUser: 'Utilisateur Actif',
  today: "Aujourd'hui",
  yesterday: 'Hier',
  currentWeek: 'Semaine actuelle',
  currentMonth: 'Mois en cours',
  lastWeek: 'La semaine dernière',
  lastMonth: 'Mois dernier',
  GGR: 'GGR',
  more: 'Plus',
  betAmount: 'Montant de la mise',
  statisticTabs: {
    0: 'Mes Joueurs',
    1: 'Mes Caissiers',
    2: 'Mes Administrateurs',
  },

  generalReport: 'Rapport général',
  filter: 'Filtre',
  standardValues: 'Valeurs standard',
  previousPeriod: 'Période précédente',
  totalBetCount: 'Nombre total de paris',
  totalBet: 'Total des mises',
  totalWon: 'Total gagné',
  commission: 'Commission',
  byProvider: 'Par fournisseur',
  winAmount: 'Montant gagné',
  betCount: 'Nombre de paris',
  incomeAmount: 'Montant des revenus',
  classification: 'Classification',
  login2: 'Identifiant',
};
